import { KLineData } from "klinecharts";
import { getPriceValue, readStyle } from "./indicatorUtils";

export const createOSMA = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const fastEMA = (values["Fast EMA"] as number) ?? 12;
  const slowEMA = (values["Slow EMA"] as number) ?? 26;
  const signalEMA = (values["MACD SMA"] as number) ?? 9;
  const applyTo = (values["Apply to"] as string) ?? "Close";
  const upColor = styles.osmaUp?.color ?? "#26A69A";
  const downColor = styles.osmaDown?.color ?? "#EF5350";

  return {
    name: "osma",
    shortName: "OSMA",
    calcParams: [fastEMA, slowEMA, signalEMA, applyTo],
    series: "normal" as const,
    figures: [{ key: "osma", title: "OSMA: ", type: "bar" }],
    styles: {
      bars: [
        {
          upColor,
          downColor,
          noChangeColor: "#888888",
        },
      ],
    },
    regenerateFigures: () => [{ key: "osma", title: "OSMA: ", type: "bar" }],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [fast, slow, sig, priceField] = (indicator.calcParams ?? [
        fastEMA,
        slowEMA,
        signalEMA,
        applyTo,
      ]) as [number, number, number, string];
      const n = dataList.length;
      const results: Array<{ osma?: number }> = new Array(n);

      const kFast = 2 / (fast + 1);
      const kSlow = 2 / (slow + 1);
      const kSig = 2 / (sig + 1);
      let emaFast = 0;
      let emaSlow = 0;
      let signal = 0;
      let haveFast = false;
      let haveSlow = false;
      let haveSig = false;

      for (let i = 0; i < n; i++) {
        const c = getPriceValue(dataList[i]!, priceField);
        if (!haveFast) {
          emaFast = c;
          haveFast = true;
        } else {
          emaFast = (c - emaFast) * kFast + emaFast;
        }
        if (!haveSlow) {
          emaSlow = c;
          haveSlow = true;
        } else {
          emaSlow = (c - emaSlow) * kSlow + emaSlow;
        }

        if (i < slow - 1) {
          results[i] = {};
          continue;
        }

        const macd = emaFast - emaSlow;
        if (!haveSig) {
          signal = macd;
          haveSig = true;
          results[i] = {};
        } else {
          signal = (macd - signal) * kSig + signal;
          if (i >= slow + sig - 2) {
            results[i] = { osma: macd - signal };
          } else {
            results[i] = {};
          }
        }
      }

      return results;
    },
  };
};
